function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { rgba } from 'polished';
export var getContainerStyles = function getContainerStyles(_ref) {
  var disabled = _ref.disabled;
  return {
    position: 'relative',
    display: 'inline-block',
    width: '36px',
    height: '20px',
    verticalAlign: 'middle',
    cursor: 'pointer',
    userSelect: 'none',
    '&&': {
      cursor: disabled && 'not-allowed',
      pointerEvents: disabled && 'none'
    }
  };
};
export var getSwitchBaseStyles = function getSwitchBaseStyles(_ref2) {
  var checked = _ref2.checked;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: '10px',
    backgroundColor: checked ? 'blue.200' : 'grey.300',
    margin: '3px 0px',
    '&[disabled]': {
      backgroundColor: checked ? 'blue.100' : 'grey.200'
    }
  };
};
export var getFocusStyles = function getFocusStyles(_ref3) {
  var focused = _ref3.focused,
      backgroundColor = _ref3.backgroundColor;

  if (!focused) {
    return {};
  }

  return {
    backgroundColor: backgroundColor
  };
};
export var getRippleWrapperStyles = function getRippleWrapperStyles(_ref4) {
  var checked = _ref4.checked,
      _ref4$focused = _ref4.focused,
      focused = _ref4$focused === void 0 ? false : _ref4$focused,
      theme = _ref4.theme;
  var _theme$colors = theme.colors,
      grey = _theme$colors.grey,
      blue = _theme$colors.blue;
  var backgroundColor = rgba(checked ? blue[200] : grey[300], 0.5);
  return _objectSpread({
    position: 'absolute',
    right: checked ? '0px' : '8px',
    left: checked ? '8px' : '-8px',
    top: '-8px',
    width: '36px',
    height: '36px',
    color: checked ? 'blue.500' : 'grey.400',
    zIndex: 1,
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: backgroundColor
    }
  }, getFocusStyles({
    focused: focused,
    backgroundColor: backgroundColor
  }));
};
export var getSwitchTrackStyles = function getSwitchTrackStyles(_ref5) {
  var checked = _ref5.checked;
  return {
    position: 'absolute',
    height: '20px',
    width: '20px',
    left: '8px',
    top: '8px',
    backgroundColor: checked ? 'blue.500' : 'grey.400',
    borderRadius: '50%',
    pointerEvents: 'none',
    '&:active': {
      transition: 'all 200ms ease'
    },
    '&[disabled]': {
      backgroundColor: checked ? 'blue.200' : 'grey.300'
    }
  };
};
export var getInputStyles = function getInputStyles(_ref6) {
  var checked = _ref6.checked;
  return {
    opacity: 0,
    position: 'absolute',
    left: checked ? '-100%' : 0,
    top: 0,
    height: '100%',
    width: '200%',
    cursor: 'pointer',
    zIndex: 1
  };
};
export var getRippleRootStyles = function getRippleRootStyles() {
  return {
    position: 'absolute',
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: 0,
    borderRadius: 'inherit',
    inset: '0px'
  };
};